import Vue from "vue";
import url from "./apiUrls";
import { store } from "../../store/store";

export const liveCourseEntity = new Vue({
  methods: {
    addLiveCourse(courseData, token) {
      const headerData = {
        Authorization: `Bearer ${token} `,
        "Content-Type": "application/json"
      };
      return new Promise((resolve, reject) => {
        this.$http
          .post(url.addLiveCourse, courseData, { headers: headerData })
          .then(res => {
            console.log(res);
            resolve(res);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    editLiveCourse(courseData, token) {
      const headerData = {
        Authorization: `Bearer ${token} `,
        "Content-Type": "application/json"
      };
      return new Promise((resolve, reject) => {
        this.$http
          .post(url.editLiveCourse, courseData, { headers: headerData })
          .then(res => {
            console.log(res);
            resolve(res);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    getLiveCourseByCourseId(courseId, token) {
      const headerData = {
        Authorization: `Bearer ${token} `,
        "Content-Type": "application/json"
      };
      const getUrl = `${url.liveCourseByCourseId}${courseId}`;
      return new Promise((resolve, reject) => {
        this.$http
          .get(getUrl, { headers: headerData })
          .then(res => {
            console.log(res);
            resolve(res);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    deleteLiveCourse(courseId) {
      const token = store.state.adminAuth.accessToken;
      const headerData = {
        Authorization: `Bearer ${token} `,
        "Content-Type": "application/json"
      };
      const getUrl = `${url.removeLiveCourse}${courseId}`;
      return new Promise((resolve, reject) => {
        this.$http
          .get(getUrl, { headers: headerData })
          .then(res => {
            console.log(res);
            resolve(res);
          })
          .catch(e => {
            reject(e);
          });
      });
    }
  }
});
